module.exports = __webpack_public_path__ + "img/boxes.3378359b.svg";